import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/siteInfo';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Romantic%20sunset%20beach%20scene%20with%20couple%20walking%20hand%20in%20hand%20along%20shoreline%2C%20golden%20warm%20light%20reflecting%20on%20gentle%20waves%2C%20soft%20pastel%20pink%20and%20orange%20sky%2C%20distant%20mountains%2C%20dreamy%20atmospheric%20haze%2C%20cinematic%20composition%2C%20luxury%20travel%20aesthetic%2C%20warm%20cream%20tones&width=1800&height=900&seq=hero-bg-love-island&orientation=landscape"
          alt="爱情岛 - 浪漫情侣旅行目的地"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/55"></div>
      </div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-semibold text-white mb-4 md:mb-6 tracking-wide">
          让每一段爱情
          <br />
          都拥有属于自己的岛屿
        </h1>
        <p className="text-base md:text-lg text-white/80 max-w-2xl mb-8 md:mb-10 leading-relaxed">
          {siteInfo.tagline} · 汇聚心动约会攻略、蜜月旅行灵感与独特爱情体验
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3">
          <Link
            to="/category/date-guide"
            className="px-8 py-3 bg-primary-500 text-background-50 dark:text-foreground-950 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            探索攻略
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 bg-white/15 backdrop-blur-sm text-white border border-white/30 rounded-full text-sm font-medium hover:bg-white/25 transition-colors whitespace-nowrap cursor-pointer"
          >
            了解我们
          </Link>
        </div>

        <div className="flex items-center gap-8 md:gap-12 mt-12 md:mt-14">
          {[
            { num: siteInfo.stats.articles.toLocaleString(), label: '篇攻略' },
            { num: siteInfo.stats.destinations, label: '个目的地' },
            { num: (siteInfo.stats.couples / 10000).toFixed(0) + '万', label: '对情侣' },
          ].map((stat, i) => (
            <div key={i} className="text-center">
              <div className="text-2xl md:text-3xl font-heading font-semibold text-white">{stat.num}</div>
              <div className="text-xs md:text-sm text-white/60 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}